import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['menu', 'button', 'iconClose', 'iconOpen']

  initialize(event) {
    const activeMenu = this.menuTarget.querySelector('.active');

    if (!activeMenu) {
      return;
    }

    const activeMenuTitle = activeMenu.textContent.trim()
    this.buttonTarget.querySelector('.current-page').textContent = activeMenuTitle;
  }

  toggle(e) {
    this.menuTarget.classList.toggle('tw-hidden');
    this.iconOpenTarget.classList.toggle('tw-hidden')
    this.iconCloseTarget.classList.toggle('tw-hidden')
  }
}
